import type { IconData } from '@stacksjs/iconify-core'

export const basicUiSettings: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m11 0l5 5v6l-5 5H5l-5-5V5l5-5zM8 11a3 3 0 1 0 0-6a3 3 0 0 0 0 6\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiSettings
